function isSSR() {
  // Mesmo não usando SSR, o Webpack gera erro no build se a verificação não for feita
  return typeof location === 'undefined'
}

export function normalize( url: string ): string {
  if ( isSSR() ) {
    return url
  }

  if ( url.startsWith( '//' ) ) {
    return location.protocol + url
  }

  if ( url.startsWith( '/' ) ) {
    return location.origin + url
  }

  return url
}

export function isExternal( url: string ): boolean {
  if ( isSSR() ) {
    return false
  }

  return !normalize( url ).startsWith( location.origin )
}

export function prune( url: string ): string {
  if ( isSSR() ) {
    return url
  }

  const { origin } = window.location
  const normalized = normalize( url )

  if ( normalized.startsWith( origin ) ) {
    return normalized.replace( origin, '' )
  }

  return url
}
